import { render } from "./Comments.vue.js?vue&type=template&id=4e106a01!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comments.vue?vue&type=template&id=4e106a01"
import script from "./Comments.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/components/community/chatrooms/comments/Comments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e106a01"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e106a01', __exports__)) {
    api.reload('4e106a01', __exports__)
  }
  
  module.hot.accept("./Comments.vue.js?vue&type=template&id=4e106a01!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Comments.vue?vue&type=template&id=4e106a01", () => {
    api.rerender('4e106a01', render)
  })

}


export default __exports__